/**
 * Read-only матрица смежности / длин дорог.
 * data: { labels: string[], matrix: (number|null)[][] }
 */
export default function TrainerAdjTable({ table, compact = false, className = '' }) {
  if (!table?.labels?.length || !table?.matrix) return null;

  const { labels, matrix } = table;

  return (
    <div className={`trainer-adj-wrap ${compact ? 'is-compact' : ''} ${className}`.trim()}>
      <table className="trainer-adj-table">
        <thead>
          <tr>
            <th aria-hidden="true" />
            {labels.map((lab) => (
              <th key={`c-${lab}`}>{lab}</th>
            ))}
          </tr>
        </thead>
        <tbody>
          {labels.map((rowLab, r) => (
            <tr key={`r-${rowLab}`}>
              <th>{rowLab}</th>
              {(matrix[r] || []).map((cell, c) => (
                <td key={`c-${r}-${c}`}>
                  {cell == null || cell === '' ? '' : cell}
                </td>
              ))}
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
}
